/**
 * @param formData {any}
 * @returns {void}
 */
module.exports = function saveForm1262ReturningUserData(formData) {
    localStorage.setItem("form1262ReturningUser", JSON.stringify(formData));
};